/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RunLogEntryDto { 
    id?: string;
    instanceId?: string;
    nodeId?: string;
    moduleId?: string;
    status?: RunLogEntryDto.StatusEnum;
    startedAt?: Date;
    scheduledFor?: Date;
    completedAt?: Date;
    statusMessage?: string;
    errorMessage?: string;
    statusMessageTruncated?: boolean;
    errorMessageTruncated?: boolean;
    hasDetails?: boolean;
    aiTotalTokens?: number;
    durationMs?: number;
    ruleName?: string;
    fileName?: string;
}
export namespace RunLogEntryDto {
    export type StatusEnum = 'PENDING' | 'RUNNING' | 'AWAITING_INPUT' | 'COMPLETED' | 'FAILED' | 'SKIPPED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        RUNNING: 'RUNNING' as StatusEnum,
        AWAITINGINPUT: 'AWAITING_INPUT' as StatusEnum,
        COMPLETED: 'COMPLETED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        SKIPPED: 'SKIPPED' as StatusEnum
    };
}